if ($('.best__item').length > 0) {
	$(window).on('load resize', function() {
		const ww = $(window).width();

		$('.best__item').css('height', 'auto');

		if (ww < 1025) {
			$('.best-col:odd').each(function() {
				const _this = $(this);
				const bestItem = _this.find('.best__item');
				const bestItemPrev = _this.prev().find('.best__item');

				const bestItemHeight = bestItem.height();
				const bestItemPrevHeight = bestItemPrev.height();

				if (bestItemHeight > bestItemPrevHeight) {
					bestItemPrev.css('height', bestItemHeight);
				} else {
					bestItem.css('height', bestItemPrevHeight);
				}
			});
		}
	});
}